import { render, staticRenderFns } from "./SupportOrderTasks.vue?vue&type=template&id=00178cd4&scoped=true"
import script from "./SupportOrderTasks.vue?vue&type=script&lang=js"
export * from "./SupportOrderTasks.vue?vue&type=script&lang=js"
import style0 from "./SupportOrderTasks.vue?vue&type=style&index=0&id=00178cd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00178cd4",
  null
  
)

export default component.exports